export const NoMenu = 0;
export const ProspectLog = 2;
export const ContactManager = 3;
export const AppointmentBook = 4;
export const ProspectCustomerInquiry = 5;
export const DailyPlanner = 6;
export const SalespersonUpLog = 7;
export const ProspectSourceReport = 8;
export const DeletedProspectReport = 9;
export const PurgeProspectDatabase = 10;
export const InternetLeadsReport = 11;
export const PhoneUpsReport = 12;
export const TargetGroups = 14;
export const EditTargetGroups = 15;
export const ListTargetGroups = 16;
export const PrintLetters = 17;
export const PrintEnvelopes = 18;
export const AfterHoursReports = 19;
export const CustomReportsSales = 20;
export const VehicleLog = 22;
export const VehicleUsedInventory = 23;
export const VehicleMakeEntry = 28;
export const VehicleModelEntry = 29;
export const VehicleColorEntry = 30;
export const ChangeVIN = 31;
export const VINVerificationReport = 32;
export const CustomStockReports = 34;
export const InventoryStockReports = 35;
export const InventoryFeaturesReports = 36;
export const NewUnitsLog = 37;
export const StockingLevelsReport = 38;
export const DailyClosingsReport = 39;
export const PotentialTradeInLog = 40;
export const InventoryAnalysisReport = 41;
export const RecalculateUsedVehicleValues = 42;
export const SalesCustomerLog = 44;
export const CustomerList = 45;
export const SalesDesk = 47;
export const SalesDeskLog = 48;
export const ClosedDeal = 49;
export const ProductSales = 50;
export const UpLog = 51;
export const PendingDealReport = 54;
export const DealSummaryReport = 55;
export const ServiceContractReport = 57;
export const InsuranceReport = 58;
export const FinancialSourceReport = 59;
export const ManagersReport = 60;
export const FISummaryReport = 61;
export const SalespersonCommissionReport = 62;
export const SalesSummary = 63;
export const CompleteSalesSummary = 64;
export const SalesSummaryReport = 66;
export const SalespersonPerformanceReport = 67;
export const SalesBreakdownReport = 68;
export const ExtendedSalesBeakdownReport = 69;
export const UsedSalesAnalysisReport = 70;
export const SalesTaxReport = 71;
export const MiscellaneousTaxesReport = 72;
export const ACPurchaseOrderEntry = 77;
export const ReceiptBook = 78;
export const SalesDOC = 79;
export const SalesGLInquiryNew = 80;
export const SalesGLInquiryUsed = 81;
export const SalesEmployeeEntry = 82;
export const ReassignSalesperson = 83;
export const ProductLog = 85;
export const VehicleModelCodeEntry = 87;
export const OptionGroupEntry = 88;
export const LenderLog = 90;
export const InsuranceLog = 93;
export const HolidaySchedule = 95;
export const ModifyFormsDisplaySequence = 96;
export const MenuSellingDefaults = 97;
export const CRMAutopilot = 98;
export const StateDefault = 99;
export const SalesDefaultSettings = 100;
export const SalesACSDefaults = 101;
export const ChangeOperatingCompany = 102;
export const SalesUserSettings = 103;
export const SalesMessageCenter = 104;
export const PDILog = 105;
export const RebateLog = 106;
export const SalesRolePermission = 107;
export const FeeLog = 108;
export const ServiceContractLog = 109;
export const Accounting = 113;
export const Payroll = 114;
export const FinanceANDInsurance = 115;
export const Parts = 116;
export const Service = 117;
export const JournalInquiry = 119;
export const ScheduleInquiry = 120;
export const SystemMenu = 121;
export const PartsDesk = 125;
export const ServicePartsInventory = 127;
export const SalesVendors = 128;
export const EmployeeViewReport = 130;
export const GLInquiry = 131;
export const EmployeeLog = 133;
export const PartsInventoryMenu = 134;
export const VehicleInventory = 136;
export const GLManualPost = 137;
export const Receipts = 139;
export const DealPostingLog = 140;
export const ScheduleReconcilliation = 141;
export const CalculateFinanceCharges = 142;
export const CheckEntry = 144;
export const CheckReconciliation = 145;
export const CheckRegisters = 146;
export const TenNinetyNines = 148;
export const AccountsPayable = 150;
export const Banks = 151;
export const TitleTracking = 166;
export const AccessoriesDue = 167;
export const OpenClosedPeriods = 171;
export const PostAutomaticEntry = 172;
export const FinancialStatements = 174;
export const PurchaseOrderEntry = 175;
export const AccountingCustomers = 176;
export const VendorLog = 177;
export const StatisticalData = 178;
export const ReopenPS = 179;
export const RolesPermissions = 184;
export const PayrollACAInfoReturn = 1623;
export const PayrollCompanyInformation = 186;
export const PayrollEmployeeInformation = 187;
export const PayrollEnterEditPayrollEntries = 195;
export const PayrollEnterEditPriorPeriodEntries = 204;
export const PayrollVoidPayrollChecks = 202;
export const PayrollVoidPriorPeriodEntries = 206;
export const PayrollEmployeeListReport = 214;
export const PayrollW2Report = 386;
export const Payroll941Report = 216;
export const PayrollFederalUnemploymentReport = 472;
export const PayrollStateUnemploymentReport = 473;
export const PayrollCloseYear = 274;
export const PayrollGenerateW2s = 1546;
export const PriceCodesSetup = 233;
export const TaxLog = 234;
export const SpecialOrders = 235;
export const JournalSetupsLog = 236;
export const LaborRatesLog = 238;
export const ScenarioDefaultsLog = 239;
export const ScheduleSetupsLog = 241;
export const ServiceAccountCodesLog = 242;
export const PartsInvoice = 243;
export const PSFees = 244;
export const ServiceFees = 245;
export const OpcodesLog = 246;
export const StandardConcernLog = 248;
export const AppointmentsLog = 250;
export const PartsAccountCodesLog = 251;
export const OrderSourceLog = 252;
export const PartsInventoryPartsType = 253;
export const PartsOrderLog = 254;
export const RepairOrderLog = 255;
export const AccountingDefaultSettings = 256;
export const AppointmentCalendar = 257;
export const PartsReturnLog = 258;
export const FormsSetups = 259;
export const OrderGroups = 260;
export const DealPostingSetupLog = 261;
export const PartsInventoryUpdate = 263;
export const VehicleNewInventory = 266;
export const ProductsReport = 275;
export const DailyReportMaintenance = 276;
export const PaymentTypes = 277;
export const ServiceSpecialOrders = 284;
export const ServicePurchaseOrders = 285;
export const LaborTimeGuides = 286;
export const CashierRepairOrders = 287;
export const CashierPartsInvoices = 288;
export const ServiceInvoiceBatchClose = 289;
export const ServiceReceiptBook = 290;
export const CustomerFollowUp = 291;
export const ServiceDailyOperatingControl = 292;
export const ServiceGeneralLedger = 293;
export const ServiceWIP = 294;
export const OpCodeEfficiency = 295;
export const AdvisorPerformance = 296;
export const ServiceSalesAnalysis = 297;
export const PartiallyClosedROs = 298;
export const TechnicianPerformanceReport = 299;
export const BodyShopSalesReport = 300;
export const OtherChargesSales = 301;
export const UpsellReport = 302;
export const SingleJobReport = 303;
export const CashierReceipts = 304;
export const CouponReport = 305;
export const ServiceDailyClose = 306;
export const FinalizedPartssales = 307;
export const ClosedROFollowup = 308;
export const ClosedPayTypeReport = 309;
export const UnpaidTechnicianLabor = 310;
export const PaidTechnicianLabor = 311;
export const ROExceptionsReport = 312;
export const RecheckReport = 313;
export const ROCountReport = 314;
export const ServiceSalesTaxReport = 315;
export const VoidModifiedHistory = 316;
export const OrderTypeAutoAssignment = 327;
export const PartsInvoiceBatchClose = 328;
export const PartsDailyClose = 329;
export const PartsReceiptBook = 330;
export const CashierReceiptsReport = 331;
export const FinalizePartsSales = 332;
export const PartsCustomers = 333;
export const PartsVendors = 334;
export const PartsAllVehicles = 335;
export const PartsDailyOperatingReport = 336;
export const PartsGeneralLedger = 337;
export const PartsChangeVINorStockNumber = 338;
export const PhysicalInventoryCountPad = 339;
export const BinCheckSheet = 340;
export const PhysicalInventoryEntry = 341;
export const BuildSpecialInventoryIndex = 342;
export const BinsPartsNotCounted = 343;
export const InventoryValuationReport = 344;
export const SalesInquiry = 345;
export const PartsWIPValue = 346;
export const PartsSalesHistory = 347;
export const OpenPartsInvoices = 348;
export const ClosedPartsInvoices = 349;
export const PartsReceiptReport = 350;
export const PartsOpCodeSalesReport = 351;
export const SalesPerformanceByActivityDate = 352;
export const SalesPerformanceByInvoiceDate = 353;
export const PartsSalesActivityReport = 354;
export const LostSalesReport = 355;
export const CustomerRouteReport = 356;
export const WholesaleNonTaxableSalesReport = 357;
export const PartsSalesTaxReport = 358;
export const PartsPriceOverrideReport = 359;
export const PartsAdjustmentReport = 360;
export const ExcessStockAndNegativeOnHand = 361;
export const CounterPadReport = 362;
export const OutstandingInventoryReport = 363;
export const RankingReport = 364;
export const PartsManagementReport = 365;
export const InventoryValueHistoryReport = 366;
export const RegularLifoPartsCostReport = 367;
export const InventoryPerformanceAnalysis = 368;
export const PartsInventoryExport = 369;
export const ROFillRateReport = 370;
export const OrderReport = 371;
export const OutstandingOrderReport = 372;
export const PartsOrderHistory = 373;
export const PartsGMReport = 374;
export const WholesaleComp = 375;
export const TireSales = 376;
export const PartsIMAReport = 377;
export const PartsClaim = 392;
export const PartsCustomerSalesReport = 378;
export const PartsVendorHistoryReport = 379;
export const PartsVendorPurchasesReport = 380;
export const PartsEmployees = 381;
export const PartsOpCodes = 383;
export const ReportingAccountSetup = 384;
export const FinancialStatementSetup = 385;
export const AutomaticEntries = 387;
export const EmployeeInformationReport = 388;
export const CommissionSchedulesLog = 389;
export const PartsRepairOrderLog = 393;
export const PartsAccessoriesDue = 394;
export const ServiceAccessoriesDue = 395;
export const PartsPurchaseOrders = 396;
export const ClosedROReport = 397;
export const OpenROsReport = 398;
export const JournalSummaryReport = 399;
export const JournalDetailReport = 400;
export const ScheduleSummaryReport = 401;
export const ScheduleDetailReport = 402;
export const ScheduleAccountSummary = 403;
export const AgenAnalysisReport = 404;
export const ServiceSalesSummary = 405;
export const GMSetups = 406;
export const KiaSetups = 408;
export const AcuraSetups = 419;
export const ChryslerSetups = 420;
export const FiatSetups = 421;
export const FordSetups = 422;
export const HondaSetups = 423;
export const InfinitiSetups = 424;
export const MazdaSetups = 425;
export const NissanSetups = 426;
export const SubaruSetups = 427;
export const ToyotaSetups = 428;
export const LexusSetups = 430;
export const PayrollQIPReport = 431;
export const TrendAnalysis = 432;
export const ExcessiveOnHandStock = 433;
export const ServiceCustomers = 439;
export const ServiceVendors = 440;
export const ServiceAllVehicles = 441;
export const VehicleBodyCodes = 443;
export const PartsInvoicesCashier = 449;
export const RIM = 454;
export const ServiceEmployees = 456;
export const GWM = 466;
export const OWSInquiries = 467;
export const SkillSetsLog = 474;
export const FordTransactions = 480;
export const RouteSheet = 482;
export const TechSystem = 484;
export const ServiceMenusSetup = 1482;
export const PartsMenusSetup = 1483;
export const AudiSetups = 1489;
export const HyundaiSetups = 1488;
export const VolkswagenSetups = 1487;
export const CHRYWarrantyPayments = 1493;
export const MyVue = 1494;
export const HYUNWarrantyBatch = 1497;
export const GMVehicleInvoice = 1500;
export const CHRYeVID = 1501;
export const UDBROHistory = 1505;
export const UDBPartSalesH = 1505;
export const UDBServiceAppointments = 1505;
export const UDBUsedVehicleSales = 1505;
export const FORDWarrantyBatch = 1511;
export const FordDORA = 1510;
export const RateLevels = 1512;
export const AppointmentSchedule = 1513;
export const ServiceEstimates = 1515;
export const PSHeaderFeesParts = 1519;
export const PSHeaderFeesService = 1520;
export const FordMail = 1525;
export const PartsRequestRoster = 1526;
export const CustomerMerge = 1527;
export const PartsPhysicalInventory = 1530;
export const SalesSummaryReportDashboardTester = 6666;
export const RepairOrderDatasetDashboard = 6667;
export const ServiceAppointmentDatasetDashboard = 6668;
export const HondaInvoiceLog = 1532;
export const ToyotaInvoiceLog = 1621;
export const LexusInvoiceLog = 1622;
export const GMWarrantyBatch = 1533;
export const PartsDeskROQuote = 1543;
export const ServiceChangeVINorStockNumber = 1547;
export const AdvancedReportsServiceSummary = 1551;
export const AdvancedReportsAdvisorScoreboard = 1556;
export const AdvancedReportsExecutiveScoreboard = 1557;
export const AdvancedReportsQuickview = 1558;
export const AdvancedReportsForecast = 1559;
export const AdvancedReportsAdvisorForecast = 1560;
export const CollectionsContractsInTransit = 1561;
export const CollectionsDealerTrades = 1562;
export const CollectionsFinanceAR = 1563;
export const CollectionsHoldback = 1564;
export const CollectionsIncentives = 1565;
export const CollectionsServiceAndParts = 1566;
export const CollectionsVehicleAR = 1567;
export const CollectionsWarranty = 1568;
export const CollectionsWholesale = 1569;
export const AdvancedReportsAgedROReport = 1573;
export const AdvancedReportsPartsSummary = 1574;
export const AdvancedReportsROPartsSummary = 1575;
export const AdvancedReportsCounterpersonScoreboard = 1576;
export const AdvancedReportsPartsExecutiveScoreboard = 1577;
export const AdvancedReportsPartsQuickview = 1578;
export const AdvancedReportsPartsForecast = 1579;
export const AdvancedReportsPartsForecastCounterperson = 1580;
export const AdvancedReportsSalesSalesSummary = 1581;
export const AdvancedReportsSalesExecutiveScoreboard = 1582;
export const AdvancedReportsSalespersonScoreboard = 1583;
export const AdvancedReportsSalesTrend = 1584;
export const AdvancedReportsCumulativeAnalysis = 1585;
export const AdvancedReportsSalesForecast = 1586;
export const AdvancedReportsSalespersonDetail = 1587;
export const AdvancedReportsSalespersonForecast = 1588;
export const AdvancedReportsFinanceSummary = 1589;
export const AdvancedReportsUnpostedDeals = 1590;
export const AdvancedReportsVIPSummary = 1591;
export const AdvancedReportsVIPDealType = 1592;
export const AdvancedReportsFinanceNewUsed = 1593;
export const AdvancedReportsSalesQuickview = 1594;
export const AdvancedReportsLenderSummary = 1599;
export const AdvancedReportsLenderScorecard = 1600;
export const AdvancedReportsLenderHistory = 1601;
export const PartsPhasing = 1596;
export const SalesGLInquiryFI = 1607;
export const PayrollGLInquiry = 1608;
export const GMTransactions = 1609;
export const GMMail = 1610;
export const GMSLTExceptions = 1612;
export const GENSWarrantyBatch = 1625;
export const SUBAWarrantyBatch = 1628;
export const PrivacyConfiguration = 1632;
export const TransactionViewer = 1633;
export const GenesisSetups = 1634;
export const VehiclePurchaseMaintenance = 1637;
export const PayrollIlliniosMonthlyWage = 1638;
export const ReportGenerator = 1700;
export const AccountingReportGenerator = 1711;
export const SalesReportGenerator = 1712;
